import { DefaultTheme } from "styled-components/macro";

export const theme: DefaultTheme = {
    headerColor: "#1e2125",
    primaryBackgroundColor: "#121212",
    primaryColor: "#6fd0aa",
    primaryTextColor: "#6fd0aa"
};
